package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.grid_customer_card_bar.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.overflowY
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.model.home.customer_card.loyalty_card.LoyaltyCardItem
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.grid_function.GridFooter
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.vh


@Composable
fun CustomerCardGridFunction(
    modifier: Modifier = Modifier,
    fillMaxWidth:Boolean,
    items: List<LoyaltyCardItem?>,
    id:String,
    onItemClick:(String)->Unit,
    loadMoreData:()->Unit,

)
{
    Column(
        modifier = modifier
            .styleModifier {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
            }
            .fillMaxHeight()
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width= Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
            .width(Dimen.gridCustomerCardWidth)
            .thenIf(
                fillMaxWidth,
                Modifier.fillMaxWidth()
            )
    )
    {
        GridCustomerCardHeader(
            numberDescending = null,
            onNumberSortClick = {

            }
        )

        CustomerCardGridItemList(
            id = id,
            items =items,
            onItemClick = {
                onItemClick(it)
            },
            loadMoreData = {
                loadMoreData()
            }
        )

        GridFooter(
            title = Strings.current().customerCards,
            width = null,
            dataSize = items.size,
            onRefreshClick = {

            }
        )


    }
}